import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import noop from 'lodash/noop';
import ProgressBar from '@adsk/bim360-matrix-react-progress-bar';
import Text from '@adsk/bim360-matrix-react-text';
import FileItem from '@adsk/bim360-matrix-react-file-item';
import './_FileUploadProgress.scss';

/**
 * FileUploadProgress component. Shows upload progress and allows upload cancel.
 */
export default class FileUploadProgress extends PureComponent {
  constructor(props) {
    super(props);
    this.renderProgress = this.renderProgress.bind(this);
  }

  renderProgress() {
    const progressBarClasses = classNames('FileUploadProgress__progress-bar', {
      'FileUploadProgress__progress-bar--upload-failed': this.props.isFailed
    });
    return (
      <ProgressBar
        className={progressBarClasses}
        max={FileUploadProgress.MAX_PROGRESS}
        now={this.props.isFailed ? FileUploadProgress.MAX_PROGRESS : this.props.progress}
      />
    );
  }

  renderFileName() {
    return <Text ellipsis={true}> {this.props.name} </Text>;
  }

  render() {
    return (
      <FileItem
        className="FileUploadProgress"
        onClose={this.props.canCancel ? this.props.onCancel : undefined}
        renderFooter={this.renderProgress}
      >
        {this.renderFileName()}
      </FileItem>
    );
  }
}

FileUploadProgress.MAX_PROGRESS = 100;

FileUploadProgress.defaultProps = {
  progress: 0,
  onCancel: noop
};

FileUploadProgress.propTypes = {
  /**
   * File name.
   */
  name: PropTypes.string.isRequired,
  /**
   * A number between 0 to 100 to indicate file upload progress.
   */
  progress: PropTypes.number,
  /**
   * True to set this file upload progress as failed.
   */
  isFailed: PropTypes.bool,
  /**
   * True to render cancel button.
   */
  canCancel: PropTypes.bool,
  /**
   * Handle cancel button click.
   */
  onCancel: PropTypes.func
};
